import { useQuery } from '@tanstack/react-query';
import { catalogMappingKeys } from '../lib/query-keys';
import { getMappingCounts } from '../lib/suggestions-api';

/*
 * How many listings wait on a person (to review, no match) and how many were
 * skipped. Undefined while it loads or when it failed: a header chip then
 * shows nothing rather than a wrong number.
 */
export function useMappingCounts(enabled = true) {
  return useQuery({
    queryKey: catalogMappingKeys.suggestionCounts(),
    queryFn: getMappingCounts,
    enabled,
    retry: false,
  });
}

/** The Mapping chip of the catalog header: suggestions to confirm plus listings with no match. */
export const toReviewTotal = (counts?: {
  toReview: number;
  noMatch: number;
}) => (counts ? counts.toReview + counts.noMatch : undefined);
